export default __webpack_public_path__ + "static/media/saman-negar.6b29a787.png";